import { createPageRoute } from '../../components/Page/utils/createPageRoute';

export const notFoundRouteRef = createPageRoute({
  id: 'not-found',
  page: { title: 'Page not found' },
});
